/* @flow */

import React from 'react';
import ResourceCard from './ResourceCard';
import ServerDrivenResourceCard from './ServerDrivenResourceCard';
import ClientDrivenResourceCard from './ClientDrivenResourceCard';
import FixedDimensionResourceCard from './FixedDimensionResourceCard';
import type { CropConfig } from './ImageCrop';
import type { FixedDimensionConfig } from './FixedDimensionResourceCard';

type Props = {
  strategy?: ResourceStrategy,
  resource?: CatalogResource,
  onUpdated: (resource: CatalogResource) => void,
  onProcessed?: (url: string) => void,
  onDeleted: () => void,
};

const OctoResourceCard = ({
  strategy,
  resource,
  onUpdated,
  onProcessed,
  onDeleted,
}: Props) => {
  const type = strategy ? strategy.type : 'template';

  const selected = (resource: BucketResource) =>
    onUpdated({
      strategy: {
        type,
        ...strategy,
        source: resource.id,
      },
      source: resource,
    });

  switch (type) {
    case 'server': {
      const configChanged = (config: CropConfig) =>
        onUpdated({
          ...resource,
          strategy: {
            ...resource.strategy,
            ...config,
          },
        });

      const config = resource ? resource.strategy : strategy;

      return (
        <ServerDrivenResourceCard
          resource={resource && resource.source}
          raw={resource && resource.raw}
          config={config}
          output={resource && resource.resource}
          onSelected={selected}
          onConfigChanged={configChanged}
          onImageProcessed={onProcessed}
          onDeleted={onDeleted}
        />
      );
    }
    case 'client': {
      const changed = (horizontalAlign, verticalAlign, parallaxEnabled) =>
        onUpdated({
          ...resource,
          strategy: {
            ...resource.strategy,
            horizontalAlign,
            verticalAlign,
            parallaxEnabled,
          },
        });

      const config = resource ? resource.strategy : strategy;

      return (
        <ClientDrivenResourceCard
          resource={resource && resource.source}
          onSelected={selected}
          onChanged={changed}
          onDeleted={onDeleted}
          {...config}
        />
      );
    }
    case 'fixed': {
      const config = resource ? resource.strategy : strategy;

      const configChanged = (config: FixedDimensionConfig) =>
        onUpdated({
          ...resource,
          strategy: {
            ...resource.strategy,
            ...config,
          },
        });

      return (
        <FixedDimensionResourceCard
          resource={resource && resource.source}
          config={config}
          onSelected={selected}
          onConfigChanged={configChanged}
          onDeleted={onDeleted}
        />
      );
    }
    case 'template': {
      return (
        <ResourceCard
          resourceType="image"
          resource={resource && resource.source}
          onSelected={selected}
          onDeleted={onDeleted}
        />
      );
    }
    default:
      console.warn(`Unknwon resource strategy ${strategy.type}. Cannot render`);
      return null;
  }
};

export default OctoResourceCard;



// WEBPACK FOOTER //
// ./src/shared/components/OctoResourceCard.js